import { render, staticRenderFns } from "./FamiliesWithIcon.vue?vue&type=template&id=77ecaa4b&scoped=true"
import script from "./FamiliesWithIcon.vue?vue&type=script&lang=js"
export * from "./FamiliesWithIcon.vue?vue&type=script&lang=js"
import style0 from "./FamiliesWithIcon.vue?vue&type=style&index=0&id=77ecaa4b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ecaa4b",
  null
  
)

export default component.exports